var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home page"},[_c('article',{staticClass:"mauto",domProps:{"innerHTML":_vm._s(_vm.about)}})])}
var staticRenderFns = []

export { render, staticRenderFns }